module.exports = __webpack_public_path__ + "img/lp-sound-wave.0d6b7519.svg";